export function convertLayerUrl(url) {
    if(isValidHttpUrl(url)) {
        return url
    }
    return window.kaartViewerUrl + url
}

export function isValidHttpUrl(string) {
    let url;
    try {
        url = new URL(string);
    } catch (_) {
        return false;
    }
    return url.protocol === "http:" || url.protocol === "https:";
}

export function getUrlSearchParams() {
    const queryString = window.location.search;
    return new URLSearchParams(queryString);
}

export function getWebsiteName() {
    const urlParams = getUrlSearchParams()
    if(urlParams.get('website') === null) {
        return 'portaalede'
    }
    return urlParams.get('website')
}

export function getCategoryName() {
    const urlParams = getUrlSearchParams()
    if(urlParams.get('category') === null) {
        return 'melding'
    }
    return urlParams.get('category')
}

export function getCategoryLinkedName() {
    const urlParams = getUrlSearchParams()
    if(urlParams.get('categoryLinked') === null) {
        return 'eikenprocessierups'
    }
    return urlParams.get('categoryLinked')
}

export function getWebsiteUrl() {
    const urlParams = getUrlSearchParams()

    if(window.location.origin === 'http://localhost:3000') {
        return 'http://localhost/phpstormprojects/geonovation/beta/kaartviewer'
    }

    if(urlParams.get('url') !== null) {
        return urlParams.get('url')
    }

    return window.location.origin + window.location.pathname.replace('/melding/index.html', '')
}
